import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=0fa7be26&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=ts"
export * from "./OrderItem.vue?vue&type=script&lang=ts"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=0fa7be26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa7be26",
  null
  
)

export default component.exports